var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wscn-http404-container" }, [
    _c("div", { staticClass: "wscn-http404" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "errorPage" },
        [
          _vm.error
            ? [
                _c("div", { staticClass: "errorPage__oops" }, [
                  _vm._v(_vm._s(_vm.errorTitle))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "errorPage__headline" }, [
                  _vm._v(_vm._s(_vm.$t("integrations.exact")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "errorPage__info" }, [
                  _vm._v(_vm._s(_vm.errorMessage))
                ])
              ]
            : [
                _c("div", { staticClass: "errorPage__oops" }, [
                  _vm._v(_vm._s(_vm.$t("success")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "errorPage__headline" }, [
                  _vm._v(_vm._s(_vm.$t("integrations.exact")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "errorPage__info" }, [
                  _vm._v(
                    _vm._s(_vm.$t("integrations.exact_registered_entities"))
                  )
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "entity-list" },
                  _vm._l(_vm.legalEntities, function(entity) {
                    return _c("li", { key: entity }, [_vm._v(_vm._s(entity))])
                  }),
                  0
                )
              ],
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.goToIntegrations } },
            [
              _vm._v(
                "\n\t\t\t\t" +
                  _vm._s(_vm.$t("integrations.back_to_integrations")) +
                  "\n\t\t\t"
              )
            ]
          )
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pic-404" }, [
      _c("img", {
        staticClass: "user-avatar",
        staticStyle: { width: "300px" },
        attrs: { src: require("@/assets/rslt-logo.png") }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }